import { useMutation, useQueryClient } from 'react-query';

// our api
import localAxiosInstance from 'services/API/LocalAPI';

// our query keys
import { KEY_ACTIONS } from 'shared/query-keys';

// our endpoints
import { updateKeyActionStatusUrl } from 'shared/api-urls';

// our constants
import { DEFAULT_STALE_TIME_FIVE_MINUTES } from 'shared/constants';

function useMutateChangeKeyActionStatus() {
	const queryClient = useQueryClient();

	return useMutation(
		async (toggleStatusPayload) => {
			const response = await localAxiosInstance.post(
				updateKeyActionStatusUrl,
				toggleStatusPayload
			);
			return response.data;
		},
		{
			staleTime: DEFAULT_STALE_TIME_FIVE_MINUTES,
			onSuccess: async () => {
				queryClient.invalidateQueries(KEY_ACTIONS);
			}
		}
	);
}

export default useMutateChangeKeyActionStatus;
